<app-pop-up>
    <app-pop-up-header *ngIf="header" class="header" [headerName]="header" (close)="closePopup()"></app-pop-up-header>
    <div class="margin-top-bottom">
        <span>{{message}}</span>
    </div>
    <app-pop-up-footer>
      <app-button [name]="'Cancel'" [type]="'outlined'" (btnClick)="closePopup()"></app-button>
      <app-button [name]="'Confirm'" [type]="'confirm'" (btnClick)="confirm()"></app-button>
    </app-pop-up-footer>
</app-pop-up>
